module.exports = __webpack_public_path__ + "img/play-icon.dcfd42e5.svg";